import { render, staticRenderFns } from "./ReturnIframe.vue?vue&type=template&id=367d91c9&"
import script from "./ReturnIframe.vue?vue&type=script&lang=ts&"
export * from "./ReturnIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports